import gql from "graphql-tag";
import { DOCUMENT_FRAGMENT } from "../document/fragment";

export const CORPORATE_FRAGMENT = gql`
  fragment CorporateInfo on Corporate {
    city
    employeesRange
    expectedMonthlyExpensesValue
    incorporationCode
    incorporationCountry
    incorporationDate
    industry
    isoCountryCode
    legalType
    postalCode
    registeredName
    accountPurposes
    street
    vatNumber
    signupProgression
    isIndividual
    isAutocomplete
    documents {
      ...DocumentInfo
    }
    existingCompany
    step
  }
  ${DOCUMENT_FRAGMENT}
`;

export const COMPANY_SEARCH_FRAGMENT = gql`
  fragment SearchCompanyResultInfo on SearchCompanyResult {
    address
    name
    incorporationCode
  }
`;
